export const MAX_YEAR = new Date().getFullYear()
export const MIN_YEAR = 1900
export const MIN_DAY_MONTH = 1
export const MAX_MONTH = 12
